<template>
  <div class="form-container position-absolute top-50 start-50 translate-middle">
    <!-- ------------ -->
    <!--    header    -->
    <!-- ------------ -->
    <div class="outer-area">
      <div class="auth-box text-center">
        <img class="mt-4" src="/bbLogo32Blue.png" alt="logo" />
        <p class="fw-lighter mt-4 mb-4 bb-app-heading">BATTLEBOARD</p>
        <!-- ------------ -->
        <!--    message   -->
        <!-- ------------ -->
        <p class="fs-6 mt-4 mb-3 bb-message">
          {{ message }}
        </p>
        <!-- ------------ -->
        <!--    login     -->
        <!-- ------------ -->
        <div class="bb-vert-text-divider">
          <router-link class="bb-link" to="/login">Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'messageView',
  //----------------------
  // passed in props
  //----------------------
  props: {
    message: String,
  },
}
</script>